// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Youtube = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <defs>
                <polygon id="a" points="0 0 24 0 24 24 0 24" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M20.4777126,16.2971907 C20.2732643,17.0652049 19.6759199,17.6438823 18.9123502,17.8483305 C17.5363247,18.2225597 12.0002222,18.2225597 12.0002222,18.2225597 C12.0002222,18.2225597 6.4632308,18.2225597 5.08720532,17.8527751 C4.32363562,17.6483268 3.72629123,17.0705383 3.521843,16.3016352 C3.15205837,14.9113872 3.15205837,12.0144447 3.15205837,12.0144447 C3.15205837,12.0144447 3.15205837,9.11216874 3.521843,7.72725421 C3.72629123,6.95923999 4.32363562,6.35567325 5.08720532,6.15211393 C6.4632308,5.77788478 12.0002222,5.77788478 12.0002222,5.77788478 C12.0002222,5.77788478 17.5363247,5.77788478 18.9123502,6.15211393 C19.6759199,6.35567325 20.2732643,6.95923999 20.4777126,7.72725421 C20.8474972,9.11750218 20.8474972,12.0144447 20.8474972,12.0144447 C20.8474972,12.0144447 20.8474972,14.9113872 20.4777126,16.2971907 M12.0002222,0 C5.37254394,0 0,5.37254394 0,12.0002222 C0,18.6270116 5.37254394,24.0004445 12.0002222,24.0004445 C18.6270116,24.0004445 24.0004445,18.6270116 24.0004445,12.0002222 C24.0004445,5.37254394 18.6270116,0 12.0002222,0"                   
                />
                <polygon fill="currentColor" points="10.191 9.38 14.819 12.01 10.191 14.639" />
            </g>
        </svg>
    );
};

export default React.memo(Youtube);
